export {};
//# sourceMappingURL=value-type.js.map